var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-inner-row operations" }, [
    _c("div", { staticClass: "triggers" }, [
      _c(
        "div",
        [
          _vm.type === "add"
            ? _c(
                "el-button",
                {
                  attrs: { no: "1", type: "success" },
                  on: {
                    click: function($event) {
                      return _vm.eventTrigger("accountingDocumentSaveAndAdd")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveAndAdd")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { no: "2", type: "success" },
              on: {
                click: function($event) {
                  return _vm.eventTrigger("accountingDocumentSave")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
          ),
          _vm.type !== "copy"
            ? _c(
                "el-button",
                {
                  attrs: {
                    no: "3",
                    type: "primary",
                    disabled: !_vm.hasId || _vm.audited
                  },
                  on: {
                    click: function($event) {
                      return _vm.eventTrigger("accountingDocumentAccept")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Audit")))]
              )
            : _vm._e(),
          _vm.type !== "copy"
            ? _c(
                "el-button",
                {
                  attrs: {
                    no: "4",
                    type: "danger",
                    disabled: !_vm.hasId || !_vm.audited
                  },
                  on: {
                    click: function($event) {
                      return _vm.eventTrigger("accountingDocumentReject")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReverseReview")))]
              )
            : _vm._e(),
          _vm.type !== "copy"
            ? _c(
                "el-button",
                {
                  attrs: { no: "5", type: "danger", disabled: !_vm.hasId },
                  on: {
                    click: function($event) {
                      return _vm.eventTrigger("accountingDocumentDeleted")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OrderDelete")))]
              )
            : _vm._e(),
          _vm.type !== "copy"
            ? _c(
                "el-button",
                {
                  attrs: { no: "6", type: "primary", disabled: !_vm.hasId },
                  on: {
                    click: function($event) {
                      return _vm.eventTrigger("accountingDocumentPrint")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { no: "7", type: "primary", disabled: !_vm.hasSelected },
              on: {
                click: function($event) {
                  return _vm.eventTrigger("accountingDocumentGridAddItem")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InsertJournalEntry")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "8", type: "danger", disabled: !_vm.hasSelected },
              on: {
                click: function($event) {
                  return _vm.eventTrigger("accountingDocumentGridDeleteItem")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_DeleteAccountingEntry")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "9", type: "primary", disabled: !_vm.hasSelected },
              on: {
                click: function($event) {
                  return _vm.eventTrigger("accountingDocumentGridExchange")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_LoanSwap")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "10", type: "primary", disabled: !_vm.hasSelected },
              on: {
                click: function($event) {
                  return _vm.eventTrigger(
                    "accountingDocumentGridCalculateBalance"
                  )
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CalculateBalance")))]
          ),
          _vm.type !== "add"
            ? _c(
                "el-button",
                {
                  attrs: { no: "11", type: "warning" },
                  on: {
                    click: function($event) {
                      return _vm.eventTrigger("accountingDocumentCancel")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }